import MultiLanguageDesignationModel from './MultiLanguageDesignationModel';
import MultiLanguageField from './MultiLanguageField';
import * as AT from '../../components/container/attributes';
import BaseModel from './BaseModel';

export default class StandardText extends MultiLanguageDesignationModel {
  constructor({
    id,
    number,
    designationFrBe = undefined,
    designationDeBe = undefined,
    designationNlBe = undefined,
    designationFrLu = undefined,
    designationDeLu = undefined,
    designationFrFr = undefined,
    designationDeDe = undefined,
    designationNlNl = undefined,
    designationEnGb = undefined,
    designationEnIn = undefined,
    designationMrIn = undefined,
    designationHiIn = undefined,
    descriptionFrBe = undefined,
    descriptionDeBe = undefined,
    descriptionNlBe = undefined,
    descriptionFrLu = undefined,
    descriptionDeLu = undefined,
    descriptionFrFr = undefined,
    descriptionDeDe = undefined,
    descriptionNlNl = undefined,
    descriptionEnGb = undefined,
    descriptionEnIn = undefined,
    descriptionMrIn = undefined,
    descriptionHiIn = undefined,
    active = false,
  }) {
    super({
      id,
      number,
      designationFrBe,
      designationDeBe,
      designationNlBe,
      designationFrLu,
      designationDeLu,
      designationFrFr,
      designationDeDe,
      designationNlNl,
      designationEnGb,
      designationEnIn,
      designationMrIn,
      designationHiIn,
    });
    this.descriptions = new MultiLanguageField({
      descriptionFrBe,
      descriptionDeBe,
      descriptionNlBe,
      descriptionFrLu,
      descriptionDeLu,
      descriptionFrFr,
      descriptionDeDe,
      descriptionNlNl,
      descriptionEnGb,
      descriptionEnIn,
      descriptionMrIn,
      descriptionHiIn,
    });
    this.description = this.descriptions.value;
    this.active = active;
  }

  static get config() {
    const config = BaseModel.config;
    config['browsable'] = true;
    return config;
  }
  get config() {
    return StandardText.config;
  }

  static get fkName() {
    return null;
  }
  static get apiRoute() {
    return 'standard_text';
  }
  static get listPageRoute() {
    return 'standardTextList';
  }
  static get detailPageRoute() {
    return 'standardTextDetail';
  }
  static get createInitColumns() {
    return {};
  }
  get fkName() {
    return StandardText.fkName;
  }
  get apiRoute() {
    return StandardText.apiRoute;
  }
  get detailPageRoute() {
    return StandardText.detailPageRoute;
  }
  get listPageRoute() {
    return StandardText.listPageRoute;
  }
  get createInitColumns() {
    return StandardText.createInitColumns;
  }

  static get joinAttrsKey() {
    return [
      'number',
      this.attributeUserLocale('designation'),
      this.attributeCompanyLocale('designation'),
      this.attributeUserLocale('description'),
      this.attributeCompanyLocale('description'),
    ];
  }

  static get listDisplayAttrs() {
    return this.getAttributes([
      'number',
      this.attributeUserLocale('designation'),
      this.attributeCompanyLocale('designation'),
      'active',
    ]);
  }

  static get browserDisplayAttrs() {
    return this.getAttributes([
      'number',
      this.attributeUserLocale('designation'),
      this.attributeCompanyLocale('designation'),
      'active',
    ]);
  }

  static get entityListDisplayAttrs() {
    return this.browserDisplayAttrs;
  }

  static get allAttributes() {
    return [
      this.NUMBER_ATTRIBUTE({}, {maxWidth: '1fr'}),
      this.ACTIVE_ATTRIBUTE(),
      new AT.BooleanAttribute({
        name: 'addressVisible',
        column: 'address_visible',
        creationValue: true,
        tableProperties: {
          header: 'hit-base.common.address',
          maxWidth: '0.5fr',
        },
      }),
      new AT.BooleanAttribute({
        name: 'transactionVisible',
        column: 'transaction_visible',
        creationValue: true,
        tableProperties: {
          header: 'hit-base.common.transaction',
          maxWidth: '0.5fr',
        },
      }),
      new AT.BooleanAttribute({
        name: 'staffVisible',
        column: 'staff_visible',
        creationValue: true,
        tableProperties: {
          header: 'hit-base.common.staff',
          maxWidth: '0.5fr',
        },
      }),
      new AT.BooleanAttribute({
        name: 'resourceVisible',
        column: 'resource_visible',
        creationValue: true,
        tableProperties: {
          header: 'hit-base.common.resource',
          maxWidth: '0.5fr',
        },
      }),
      new AT.BooleanAttribute({
        name: 'purchaseVisible',
        column: 'purchase_visible',
        creationValue: true,
        tableProperties: {
          header: 'hit-base.common.purchase',
          maxWidth: '0.5fr',
        },
      }),
      new AT.BooleanAttribute({
        name: 'equipmentVisible',
        column: 'equipment_visible',
        creationValue: true,
        tableProperties: {
          header: 'hit-base.common.equipment',
          maxWidth: '0.5fr',
        },
      }),
      new AT.BooleanAttribute({
        name: 'projectVisible',
        column: 'project_visible',
        creationValue: true,
        tableProperties: {
          header: 'hit-base.common.project',
          maxWidth: '0.5fr',
        },
      }),
      new AT.BooleanAttribute({
        name: 'actionVisible',
        column: 'action_visible',
        creationValue: true,
        tableProperties: {
          header: 'hit-base.common.action',
          maxWidth: '0.5fr',
        },
      }),
    ]
      .concat(
        this.generateMultiLanguageField({
          key: 'designation',
          attributeClass: AT.StringAttribute,
          header: 'hit-base.common.designation',
        }),
      )
      .concat(
        this.generateMultiLanguageField({
          key: 'description',
          attributeClass: AT.RichTextAttribute,
          header: 'hit-base.common.description',
        }),
      );
  }
}
